import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MealModel } from 'src/app/nutrigenic/models/home/meal-model';
import { MealCategoryModel } from 'src/app/nutrigenic/models/home/meal-category-model';
import { PlanService } from 'src/app/nutrigenic/services/plan/plan.service';
import { MealTagModel } from 'src/app/nutrigenic/models/home/meal-tag-model';

@Component({
  selector: 'app-meals-search-bar',
  templateUrl: './meals-search-bar.component.html',
  styleUrls: ['./meals-search-bar.component.scss']
})
export class MealsSearchBarComponent {

  filteredMeals: MealModel[] = [];
  search: string = '';
  searchIcon: boolean = true;
  categories: MealCategoryModel[] = [];
  selectedCategories: MealCategoryModel[] = [];
  tagItems: MealTagModel[] = [];

  @Input() meals: MealModel[] = [];
  @Input() isMobile: boolean = false;
  @Input() selectedTagId: number = 4; // General Health by default
  @Input() selectedCategoryIds: number[] = [];
  @Input() hideCategories: boolean = false;

  
  @Output() selectedTagChange = new EventEmitter<MealModel[]>();
  @Output() selectedCategoryChange = new EventEmitter<MealModel[]>();
  @Output() searchChange = new EventEmitter<MealModel[]>();
  @Output() resetSearch = new EventEmitter<void>();

  

  constructor(private planService: PlanService) {}


  ngOnInit(){
    // mark categories if pre-selected
    this.planService.getMealCategories().subscribe((categories: MealCategoryModel[]) => {

      if(this.selectedCategoryIds.length > 0){
        categories.forEach(category => { 
            this.selectedCategoryIds.forEach((selectedCategory: number) => {
                if (category.id == selectedCategory) {
                  category.selected = true;
                }
            });
        })
      }
      

      this.categories = categories;
      this.selectedCategories = this.categories.filter((category: MealCategoryModel) => category.selected);

      
      this.onMealTagChange(this.selectedTagId);
      
    });



    const tagsObservable = this.hideCategories
      ? this.planService.getAddonsTags(true)
      : this.planService.getMealTags();

    tagsObservable.subscribe((tags: MealTagModel[]) => {
      this.tagItems = tags;
      if (this.hideCategories) this.selectedTagId = 0;
    });
  }

  filterByMealTag(mealsList: MealModel[], tagId: number) {
        if(tagId == 0) return mealsList;
        return mealsList.filter((meal: MealModel) =>
          meal.categories.map((tag: any) => tag.id).includes(tagId)
      );
  }
  
  filterByMealCategory(mealsList: MealModel[], categories: MealCategoryModel[]) {
    if (categories.length === 0) return mealsList;
        const categoryIds = categories.map(cat => cat.id);
        return mealsList.filter((meal: MealModel) =>
            meal.categories_meals.some((category: any) => categoryIds.includes(category.id))
        );
    }

  
  onMealTagChange(tagId: any) {
    this.selectedTagId = tagId;
    //setTimeout(() => {
        this.filteredMeals = this.filterByMealTag(this.meals, this.selectedTagId);
        this.filteredMeals = this.filterByMealCategory(this.filteredMeals, this.selectedCategories);

        this.selectedTagChange.emit(this.filteredMeals);

    //}, 1000);
  }
  
  onSelectedCategory(categories: MealCategoryModel[]) {
      this.selectedCategories = categories;
      //setTimeout(() => {
            this.filteredMeals = this.filterByMealCategory(this.meals, this.selectedCategories);
            this.filteredMeals = this.filterByMealTag(this.filteredMeals, this.selectedTagId);

          this.selectedCategoryChange.emit(this.filteredMeals);

      //}, 1000);
  }
  
  inputTextChange(event: any) {
      console.log(event);
      
      this.filteredMeals = this.filterByMealCategory(this.meals, this.selectedCategories);
      this.filteredMeals = this.filterByMealTag(this.filteredMeals, this.selectedTagId);

      var x = event;
      if (this.search == '') {
          this.searchIcon = true;
      }
      else {
          this.searchIcon = false;
          let tempFilteredMeals: MealModel[] = [];
          
          this.filteredMeals.forEach((item:any) => {
              const find = item.name.toLowerCase().includes(this.search.toLowerCase());
              if(find) tempFilteredMeals.push(item);
          });

          if(tempFilteredMeals.length > 0) this.filteredMeals = tempFilteredMeals;
      }
      
      this.searchChange.emit(this.filteredMeals);
      
  }
  
  searchReset() {
      this.search = '';
      this.searchIcon = true;
      this.selectedCategories = [];
      this.selectedCategoryIds = [0];
      this.selectedTagId = 2;
      this.onMealTagChange(this.selectedTagId);
      this.resetSearch.emit();
  }
}